<template>
  <div class="home">
    <div class="bgContainer">
      <!-- <img class="bg" src="../assets/login_mainbg.jpg" alt="" /> -->
      <!-- <img class="bg" src="../assets/bg.jpg" alt="" /> -->
      <!-- <img class="bg" src="../assets/bg1.jpg" alt="" /> -->
    </div>
    <div class="logoContainer">
      <img class="logo" src="../assets/logo.jpg" alt="" srcset="" />
      <p class="title">统建系统</p>
    </div>
    <div class="entranceContainer">
      <div class="wangContainer">
        <p class="wang" @click="jump('https://app.ceec.net.cn')">
          <img class="circle_img" src="../assets/右箭头.png" alt="" />
          <span class="circle_title">一张网入口</span>
        </p>
        <p class="internet" @click="jump('https://vpn1.ceec.net.cn')">
          <img class="circle_img" src="../assets/右箭头.png" alt="" />
          <span class="circle_title">互联网入口</span>
        </p>
      </div>
      <div class="downloadVPN">
        <a
          target="_blank"
          title="操作手册"
          rel="noopener noreferrer"
          @click="showPdf('VPN操作说明')"
          >操作指南
        </a>
      </div>
      <div class="download" @mouseleave="showList(false)">
        <a
          href="https://e.ceec.net.cn"
          target="_blank"
          title="https://e.ceec.net.cn"
          rel="noopener noreferrer"
          >下载移动门户“e能建”</a
        >
      </div>
      <!-- <div class="download" @mouseleave="showList(false)">
        <span @mouseenter="showList(true)">常用链接</span>
        <el-card class="box-card"  v-if="ifShowList" @mouseenter="showList(true)">
          <div v-for="o in 3" :key="o" class="text item">
            <a href="" target="_blank" rel="noopener noreferrer">{{
              "列表内容 " + o
            }}</a>
          </div>
        </el-card>
      </div> -->
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      ifPdf: false,
      pdfUrl: '',
      url: { url: require('../assets/logo.gif') },
      ifShowList: false
    }
  },
  created() {
  },
  methods: {
    jump(url) {
      window.open(url, "_blank");
    },
    showPdf(url) {
      window.open('/static/pdf/' + url + '.pdf')
    },
    showList(val) {
      this.ifShowList = val
    }
  }
}
</script>
<style scoped>
.home {
  background-image: url("../assets/login_bg.png");
  background-size: 100% 100%;
  background-attachment: fixed;
  width: 100%;
  height: 100%;
}
.wang,
.internet {
  cursor: pointer;
}
.bgContainer {
  width: 1920px;
  position: absolute;
}
.bg {
  width: 100%;
  height: 100%;
}
.logoContainer {
  position: absolute;
  top: 4%;
  width: 100%;
}
.logoContainer img {
  margin-left: 2%;
  width: 36%;
}
.title {
  font-size: 54px;
  font-weight: 900;
  color: #fff;
  text-indent: 20px;
  position: relative;
  top: -22px;
  display: inline-block;
  letter-spacing: 15px;
  text-shadow: #333 3px 4px 5px;
}
.entranceContainer {
  position: absolute;
  right: 0;
  bottom: 17%;
  width: 430px;
}
.wangContainer {
  height: 70px;
}
.wangContainer p {
  float: left;
}
.internet {
  margin-left: 5%;
}
.circle_img {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  margin-top: -17px;
  margin-right: -10px;
}
.circle_title {
  text-align: center;
  color: #fff;
  font-size: 30px;
  height: 70px;
  line-height: 70px;
  display: inline-block;
  padding: 0 10px 0 10px;
  font-weight: 900;
  text-shadow: #333 3px 4px 5px;
}
.downloadVPN {
  width: 100%;
  height: 50px;
}
.download {
  height: 35px;
  line-height: 35px;
}
.downloadVPN a {
  font-size: 25px;
  color: #fff;
  text-shadow: #333 3px 4px 5px;
  height: 60px;
  line-height: 50px;
  cursor: pointer;
  text-decoration: none;
  float: right;
}

.download a {
  font-size: 25px;
  color: #fff;
  text-shadow: #333 3px 4px 5px;
  float: right;
  display: block;
  text-decoration: none;
  cursor: pointer;
}
@media only screen and (max-width: 2134px) {
  .title {
    font-size: 54px;
    top: -29px;
    text-indent: 30px;
  }
  .circle_title {
    font-size: 28px;
    height: 36px;
    line-height: 36px;
  }
  .circle_img {
    width: 28px;
    height: 28px;
    margin-top: -12px;
  }
  .downloadVPN a {
    font-size: 23px;
    margin-right: 5%;
    height: 44px;
    line-height: 44px;
  }
  .download a {
    font-size: 23px;
    margin-right: 5%;
    line-height: 54px;
  }
  .entranceContainer {
    bottom: 17%;
    width: 380px;
  }
  .wangContainer {
    height: 60px;
    line-height: 60px;
  }
  .downloadVPN {
    margin-right: 15%;
    line-height: 36px;
  }
}
@media only screen and (max-width: 1920px) {
  .title {
    font-size: 54px;
    top: -24px;
    text-indent: 30px;
  }
  .circle_title {
    font-size: 28px;
    height: 36px;
    line-height: 36px;
  }
  .circle_img {
    width: 28px;
    height: 28px;
    margin-top: -12px;
  }
  .downloadVPN a {
    font-size: 23px;
    margin-right: 5%;
    height: 44px;
    line-height: 44px;
  }
  .download a {
    font-size: 23px;
    margin-right: 5%;
    line-height: 54px;
  }
  .entranceContainer {
    bottom: 15%;
    width: 380px;
  }
  .wangContainer {
    height: 60px;
    line-height: 60px;
  }
  .downloadVPN {
    margin-right: 15%;
    line-height: 36px;
  }
}
@media only screen and (max-width: 1746px) {
  .title {
    font-size: 50px;
    top: -21px;
    text-indent: 24px;
  }
  .circle_title {
    font-size: 25px;
    height: 36px;
    line-height: 36px;
  }
  .circle_img {
    width: 28px;
    height: 28px;
    margin-top: -12px;
  }
  .downloadVPN a {
    font-size: 22px;
    margin-right: 4%;
    height: 34px;
  }
  .download a {
    font-size: 22px;
    line-height: 70px;
  }
  .entranceContainer {
    bottom: 14%;
    width: 345px;
  }
  .wangContainer {
    height: 50px;
    line-height: 50px;
  }
  .downloadVPN {
    height: 36px;
    line-height: 36px;
  }
}
@media only screen and (max-width: 1600px) {
  .title {
    font-size: 46px;
    top: -17px;
  }
  .circle_title {
    font-size: 22px;
    height: 36px;
    line-height: 36px;
  }
  .circle_img {
    width: 24px;
    height: 24px;
    margin-top: -9px;
  }
  .downloadVPN a {
    font-size: 20px;
    margin-right: 6%;
    height: 33px;
    line-height: 60px;
  }
  .download a {
    font-size: 20px;
    line-height: 78px;
  }
  .entranceContainer {
    bottom: 12%;
    width: 307px;
  }
  .wangContainer {
    height: 40px;
    line-height: 33px;
  }
  .downloadVPN {
    height: 36px;
    line-height: 36px;
  }
}
@media only screen and (max-width: 1440px) {
  .title {
    font-size: 36px;
    top: -20px;
    letter-spacing: 12px;
  }
  .circle_title {
    font-size: 22px;
    height: 40px;
    line-height: 40px;
  }
  .circle_img {
    width: 24px;
    height: 24px;
    margin-top: -7px;
  }
  .downloadVPN a {
    font-size: 19px;
    margin-right: 5%;
    height: 27px;
  }
  .download {
    line-height: 20px;
  }
  .download a {
    font-size: 19px;
    margin-right: 5%;
    line-height: 100px;
  }
  .entranceContainer {
    bottom: 13%;
    width: 306px;
  }
  .wangContainer {
    height: 40px;
    line-height: 40px;
  }
  .downloadVPN {
    height: 30px;
    line-height: 30px;
  }
}
@media only screen and (max-width: 1280px) {
  .title {
    font-size: 36px;
    top: -14px;
    letter-spacing: 10px;
  }
  .circle_title {
    font-size: 18px;
    height: 30px;
    line-height: 30px;
  }
  .circle_img {
    width: 20px;
    height: 20px;
    margin-top: -5px;
  }
  .downloadVPN a {
    font-size: 17px;
    height: 30px;
    line-height: 42px;
    margin-right: 5%;
  }
  .download a {
    font-size: 17px;
    margin-right: 6%;
    line-height: 50px;
  }
  .entranceContainer {
    bottom: 14%;
    width: 254px;
  }
  .wangContainer {
    height: 35px;
    line-height: 30px;
  }
  .downloadVPN {
    height: 30px;
    line-height: 30px;
  }
}
</style>
